import React from 'react';
import PropTypes from 'prop-types';

import useV3OfferPool from '../../hooks/useV3OfferPool';

// O-3541: Simple-editor variant of V3OfferPoolToggle. Gated behind the
// multi_artist_v3_offers entitlement; visible even for a single-artist lineup
// (the booker may add more artists).
const MODES = [
  { value: 'independent', label: 'Independent' },
  { value: 'pool', label: 'Pool' },
];

const SimplePoolToggle = ({ team, offer }) => {
  const { setMode, isSavingPool } = useV3OfferPool();

  if (!team?.package?.multi_artist_v3_offers) return null;

  const defaultMode = team?.package?.default_v3_offer_display_mode || 'independent';
  const mode = offer?.v3_offer_pool?.mode || defaultMode;

  const handleClick = (next) => {
    if (next === mode || isSavingPool) return;
    setMode(next);
  };

  return (
    <div className="simple-pool-toggle" data-testid="simple-pool-toggle">
      <span className="simple-pool-toggle__label">Lineup payout</span>
      <span className="simple-pool-toggle__segmented" role="radiogroup" aria-label="Lineup payout mode">
        {MODES.map((opt) => (
          <button
            type="button"
            key={opt.value}
            className={`simple-pool-toggle__btn ${mode === opt.value ? 'simple-pool-toggle__btn--active' : ''}`}
            onClick={() => handleClick(opt.value)}
            aria-pressed={mode === opt.value}
            disabled={isSavingPool}
          >
            {opt.label}
          </button>
        ))}
      </span>
    </div>
  );
};

SimplePoolToggle.propTypes = {
  team: PropTypes.object,
  offer: PropTypes.object,
};

SimplePoolToggle.defaultProps = { team: null, offer: null };

export default SimplePoolToggle;
